const updateTgUserData = (state, action) => {


    if (state === undefined) {
        return {
            uname : null ,
            phone: ''
        };
    }

    switch(action.type) {

        case 'SET_TG_USER_DATA':
            return  action.payload ;

        default:
            return state.tguserdata;
    }
};

export default updateTgUserData;